// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2OWzH","topBottomGutter":"Layout_topBottomGutter__G1PY8"};